export default "__VITE_ASSET__DPGDUE0y__"